import styled from "@emotion/styled";

import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const bannerHeight = 112;
export const bannerBorderRadius = 8;
export const bannerFullHeight = bannerHeight + bannerBorderRadius * 2;

export const PopupBanner = styled.article(props => ({
    zIndex: 1,
    position: "absolute",
    height: `${bannerHeight}px`,
    paddingLeft: "20px",
    paddingRight: "40px",
    backgroundColor: theme(props).keyPalette.primaryBackgroundColor,
    maxWidth: "1000px",
    borderRadius: `${bannerBorderRadius}px`,
    ...theme(props).typography.primary.css(),
}));

export const BannerContainer = styled.section(() => ({
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
}));

export const ContentContainer = styled.article(() => ({
    display: "flex",
    alignItems: "center",
    maxWidth: "800px",
}));

export const BannerAside = styled.aside(() => ({
    minWidth: "102px",
}));

export const BannerHeader = styled.aside(() => ({
    marginBottom: "8px",
    fontSize: "18px",
    fontWeight: "700",
}));

export const BannerContent = styled.aside(() => ({
    fontSize: "16px",
}));

export const BannerClose = styled.aside(_ => ({
    position: "absolute",
    top: "14px",
    right: "16px",
}));

export const BannerIcon = styled.aside(() => ({
    minWidth: "64px",
    marginRight: "16px",
    height: "64px",
}));

export const BannerIconForPortrait = styled.aside(_ => ({
    position: "relative",
    transform: "translateY(-42px)",
}));
